import React from 'react'
import img1 from "../../assets/services-1.webp"
import img2 from "../../assets/services-2.webp"
import img3 from "../../assets/services-3.webp"
import img4 from "../../assets/services-4.webp"
import image1 from "../../assets/service2-1.webp" 
import image2 from "../../assets/service2-2.webp" 
import image3 from "../../assets/service2-3.webp" 
import image4 from "../../assets/service2-4.webp" 
import AdImg1 from "../../assets/Ad-1.webp"
import AdImg2 from "../../assets/Ad-2.webp"
import AdImg3 from "../../assets/Ad-3.webp"
import AdImg4 from "../../assets/Ad-4.webp"
import Slider from "react-slick"

const Services = () => {

    const settings = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
      };
    

  return (
    <div>
       <div id='' className='my-16'>


         <div id='services-sec' className='ser-sec-1'>
            <div id='img-div' className='flex justify-center flex-wrap'>
                <img id='img-web' src={image1} alt='vwrap'/>
                <img id='img-mobile' src={img1} alt='vwrap'/>
            </div>
            <div id='text-div'>
              <p className='flex'>
              </p>
              <p id='count1' className='text-white '>01</p>
                <p id='heading' className='border-l-0 p-0 m-0'>360 ADVERTISEMENT <span>PLANNING</span></p>
                 <p className='text-white'>360°Marketing Campaign is a complete creative campaign idea across all the brand’s marketing mix elements, designed to implement a strategic brand strategy.</p>
            </div>
         </div>


         <div id='services-sec' className='ser-sec-2'>
            <div id='img-div' className='flex justify-center flex-wrap'>
            <img id='img-web' src={image2} alt='vwrap'/>
                <img id='img-mobile' src={img2} alt='vwrap'/>
                
            </div>
            <div id='text-div'>
            <p id='count2' className='text-white '>02</p>
                <p id='heading'  className='border-l-0 p-0 m-0'>OUT OF HOME ADVERTISEMENT <span>PLATFORM PROVIDER</span></p>
                 <p className='text-white'>Vwrap is a promising advertisement agency, established with an aim to provide effective quality out of home advertisement solutions to the marketers with its creative, integrated and ever more engaging advertisement campaigns nationwide.</p>
            </div>
         </div>



         <div id='services-sec' className='ser-sec-3'>
            <div id='img-div' className='flex justify-center flex-wrap'>
            <img id='img-web' src={image3} alt='vwrap'/>
                <img id='img-mobile' src={img3} alt='vwrap'/>
                
            </div>
            <div id='text-div'>
                <p id='count3' className='text-white '>03</p>
                <p id='heading' className='border-l-0 p-0 m-0'>ON - VEHICLE ADVERTISEMENT <span>PLATFORM PROVIDER</span></p>
                 <p className='text-white'>Vwrap takes brands street to street to cover every possible corner of the city so it’s message is seen everywhere and by every group of age through our concept of mobile advertisement.</p>
            </div>
         </div>




         <div id='services-sec' className='ser-sec-4'>
            <div id='img-div' className='flex justify-center flex-wrap'>
            <img id='img-web' src={image4} alt='vwrap'/>
                <img id='img-mobile' src={img4} alt='vwrap'/>
                
            </div>
            <div id='text-div'>
            <p id='count4' className='text-white '>04</p>
                <p id='heading' className='border-l-0 p-0 m-0'>VINYL PRINTING <span>SERVICES</span></p>
                 <p className='text-white'>We deal in the designing and printing of Flex Banners, Billboards , Vinyl Sticker, Promotional Items, Banner Stands (Roller Stand X Stand etc) Industrial-Scale Prints, Exhibitions, Magazines ads and Front Lit, Back Lit Pana flex / Flex, and much more in Karachi.</p>
            </div>
         </div>
         

         <div></div>


       </div>

       <div id='ad-images' className='flex my-40'>
        <img width={"25%"} src={AdImg1} alt='vwrap'/>
        <img width={"25%"} src={AdImg2} alt='vwrap'/>
        <img width={"25%"} src={AdImg3} alt='vwrap'/>
        <img width={"25%"} src={AdImg4} alt='vwrap'/>
        <img id='animated-img' width={"25%"} src={AdImg1} alt='vwrap'/>
        <img id='animated-img' width={"25%"} src={AdImg2} alt='vwrap'/>
        <img id='animated-img' width={"25%"} src={AdImg3} alt='vwrap'/>
        <img id='animated-img' width={"25%"} src={AdImg4} alt='vwrap'/>
      </div>


      <div id='ad-carousel' >
      <div className='w-9/12 my-8'>
        <Slider {...settings}>
          <div>
          <img src={AdImg1} alt='vwrap'/>
          </div>
          <div>
          <img src={AdImg2} alt='vwrap'/>
          </div>
          <div>
          <img src={AdImg3} alt='vwrap'/>
          </div>
          <div>
          <img src={AdImg4} alt='vwrap'/>
          </div>
          
        </Slider>
      </div>
      </div>

    </div>
  )
}

export default Services
